<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>scorm course</title>
</head>
<body>

</body>
</html>



// WEBPACK FOOTER //
// ./src/app/scorm-course.component.html